<script setup>
import {defineProps} from 'vue'
import {helpers} from "@/Services/helpers.js";
import CLink from "@/Components/CLink.vue";

const props = defineProps({
    product: {
        type: Object,
        required: true
    },
    activeColor: {
        type: Object,
        default: null
    }
})

const hasColor = (color) => {
    return color.code !== 'SEC';
}

const getGradientStyle = (color) => {
    return `background: linear-gradient(127deg, ${color.hex ?? '#FFFFFF'} 50%, ${color.hexSec ?? color.hex ?? '#FFFFFF'} 50%);`
}

const selectedColor = (color) => {

    return props.activeColor ? helpers.firstLetterUppercase(props.activeColor?.color) === color.title : false
}

//Utilizar caso tenha mais de uma referencia que necessite mostrar o nome.
const nomColorRef = (color) => {
    return "Cor Única"
}

</script>

<template>
    <v-sheet v-if="props.product.variations !== undefined" class="my-2">
        <template v-for="(color, index) in props.product.colors" :key="index">
            <c-link v-if="hasColor(color)" :href="selectedColor(color) ? props.product.detail_url : color.variationUrl">
            <v-btn
                :style="getGradientStyle(color)"
                :class="{ 'v-btn--active': selectedColor(color)}"
                class="mb-1 pa-0 ma-1"
                min-width="30px"
                width="30px"
                height="30px"
                :title="color.title"
                variant="flat"
                rounded
                elevation="0"
                border
            />
            </c-link>
            <v-chip v-else border color="grey-darken-1">
                <p class="text-subtitle-2">{{ nomColorRef(color) }}</p>
            </v-chip>
        </template>
    </v-sheet>
</template>

<style scoped>
.v-btn--active {
    opacity: 0.8;
    transform: scale(1.2);
    transition: all 0.2s ease;
    box-shadow: 0 0 3px 1px rgb(0 0 0 / 30%) !important
}
</style>